<template>
    <div class="content-wrapper" style="position: relative;">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="radius-slider-container" v-if="selectedLocation">
                    <label for="radiusSlider" class="text-white">Ajuster le Rayon (mètres) :</label>
                    <input type="range" id="radiusSlider" min="25" max="1000" step="25" 
                            v-model="currentRadius" @input="updateRadius" />
                    <span>{{ currentRadius }}</span>
                </div>
                <div v-else>
                    <h4>{{ $t('locations') }}</h4>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
                <button class="btn btn-primary" @click="openAddEditModal">
                    <app-icon name="plus"></app-icon>
                </button>
                <div class="search-bar-container">
                    <input
                        type="text"
                        v-model="searchQuery"
                        @input="onSearch"
                        placeholder="Rechercher un lieu..."
                        class="form-control search-bar"
                    />
                    <div class="autocomplete-results" v-if="filteredLocations.length">
                        <ul>
                            <li
                                v-for="location in filteredLocations"
                                :key="location.id"
                                @click="centerMap(location)"
                            >
                                {{ location.name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <app-modal :modal-id="modalId" v-if="isModalActive" :title="modalTitle" :preloader="preloader"
                                @submit="saveLocation" @close-modal="closeModal" modal-size="large">
            <template slot="header">
                    <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
                    <button type="button" class="close outline-none" @click.prevent="closeModal">
                        <span>
                            <app-icon :name="'x'"></app-icon>
                        </span>
                    </button>
            </template>
            <template slot="body">
                <app-overlay-loader v-if="preloader" />
                <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                        :data-url='selectedLocation ? `locations/${selectedLocation.id}` : `locations`'>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="name">Nom :</label>
                                <input type="text" id="name" class="form-control" 
                                        v-model="form.name" placeholder="Entrez le nom" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="code">Code :</label>
                                <input type="text" id="code" class="form-control" 
                                        v-model="form.code" placeholder="Entrez le code" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="lat">Latitude :</label>
                                <input type="text" id="lat" class="form-control" v-model="form.lat" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="lng">Longitude :</label>
                                <input type="text" id="lng" class="form-control" v-model="form.lng" />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="appSettingsTimeZone">{{ $t('time_zone') }}</label>
                                <app-input id="appSettingsTimeZone"
                                            type="select"
                                            v-model="form.time_zone"
                                            :list="timeZones"/>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="code">Description :</label>
                                <input type="text" id="code" class="form-control" 
                                        v-model="form.description" placeholder="Entrez la description" />
                            </div>
                        </div>
                    </div>
                </form>
            </template>
                <template slot="footer">
                    <button type="button" class="btn btn-primary mr-2" @click="saveLocation">{{ $t('save') }}</button>
                    <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                        {{ $t('cancel') }}
                    </button>
                    <button v-if="selectedLocation" @click="selectedLocation ? deleteConfirmationModalActive = true : null;"
                            class="btn btn-xs btn-danger" style="float: left;">
                        <app-icon name="trash"></app-icon>
                    </button>
                </template>
        </app-modal>

        <!-- Map Container Start -->
        <div id="map" ref="map"></div>
        <!-- Map Container Stop -->

        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="location-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import axios from "axios";
import * as actions from "../../../Config/ApiUrl";
import { ModalMixin } from "../../../Mixins/ModalMixin";
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

export default {
    extends: CoreLibrary,
    mixins: [FormMixin, ModalMixin],
    name: 'AppLocations',
    data() {
        return {
            map: null,
            locations: [],
            selectedLocation: null,
            preloader: false,
            isModalActive: false,
            modalId: 'location-add-edit-modal',
            modalTitle: `${this.$t('new-location')}`,
            currentRadius: 400,
            timeZones: [],
            form: {
                name: "",
                code: "",
                lat: "",
                lng: "",
                description: "",
                time_zone: "",
            },
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            tableId: 'locations-table',
            rowData: {},
            searchQuery: "",
            filteredLocations: [],
        };
    },
    mounted() {
        this.loadGoogleMaps(() => {
            this.initMap();
            this.loadLocations();
            this.getTimeZones();
            // this.initSearchBar();
        });
    },
    methods: {
        loadGoogleMaps(callback) {
            if (!window.google) {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBmBnLsnWlQYdXtXPgthACMf2ObWFAHIfs&libraries=places`;
                script.async = true;
                script.defer = true;
                script.onload = callback;
                document.head.appendChild(script);
            } else {
                callback();
            }
        },
        openAddEditModal(){
            $("#location-add-edit-modal").modal('show');
            this.isModalActive = true;
        },
        closeModal() {
            $("#location-add-edit-modal").modal('hide');
            this.isModalActive = false;
        },
        initMap() {
            this.map = new google.maps.Map(this.$refs.map, {
                center: { lat: -3.8626, lng: 23.4878 },
                zoom: 5,
            });

            this.map.addListener("click", (event) => {
                this.onMapClick(event);
            });
        },
        onMapClick(event) {
            this.selectedLocation = null;
            this.resetForm();
            this.form.lat = event.latLng.lat();
            this.form.lng = event.latLng.lng();
            this.openAddEditModal();
        },
        loadLocations() {
            axios.get(actions.LOCATION).then((response) => {
                this.locations = response.data.map((location) => {
                    return {
                        id: location.id,
                        name: location.name,
                        code: location.code,
                        description: location.description,
                        lat: location.latitude,
                        lng: location.longitude,
                        radius: location.radius,
                        time_zone: location.time_zone,
                    };
                });
                this.locations.forEach((location) => {
                    this.addLocationMarker(location);
                });
            });
        },
        addLocationMarker(location) {
            const lat = parseFloat(location.lat);
            const lng = parseFloat(location.lng);

            if (isNaN(lat) || isNaN(lng)) {
                console.error("Invalid latitude or longitude for location:", location);
                return;
            }

            const marker = new google.maps.Marker({
                position: { lat, lng },
                map: this.map,
                draggable: true,
            });

            const circle = new google.maps.Circle({
                strokeColor: "#2983D2",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#2983D2",
                fillOpacity: 0.35,
                map: this.map,
                center: { lat, lng },
                radius: location.radius,
            });

            const infoWindow = new google.maps.InfoWindow({
                content: `<div><strong>${location.name}</strong><br>Code: ${location.code}</div>`
            });

            marker.addListener("mouseover", () => {
                infoWindow.open(this.map, marker);
            });

            marker.addListener("mouseout", () => {
                infoWindow.close();
            });

            marker.addListener("click", () => this.selectLocation(location));
            marker.addListener("dblclick", () => {
                this.selectLocation(location);
                this.openAddEditModal();
            });
            marker.addListener("dragend", (event) => {
                location.lat = event.latLng.lat();
                location.lng = event.latLng.lng();
                circle.setCenter({ lat: location.lat, lng: location.lng });
                const updatedLocation = {
                    id: location.id,
                    name: location.name,
                    code: location.code,
                    radius: location.radius,
                    latitude: location.lat,
                    longitude: location.lng,
                    description: location.description,
                    time_zone: location.time_zone,
                };
                this.updateLocation(updatedLocation);
            });

            location.marker = marker;
            location.circle = circle;
        },
        saveLocation() {
            if (this.selectedLocation) {
                this.selectedUrl = `locations/${this.selectedLocation.id}`;
                // Update existing location
                const updatedLocation = { 
                    name: this.form.name,
                    code: this.form.code,
                    radius: this.currentRadius,
                    latitude: this.selectedLocation.lat,
                    longitude: this.selectedLocation.lng,
                    description: this.form.description,
                    time_zone: this.form.time_zone
                };
                this.save(updatedLocation)
            } else {
                // Create new location
                const newLocation = { 
                    ...this.form, 
                    radius: this.currentRadius,
                    latitude: this.form.lat,
                    longitude: this.form.lng,
                    description: this.form.description
                };
                this.save(newLocation);
            }
            this.resetForm();
            this.loadLocations();
        },
        selectLocation(location) {
            this.selectedLocation = location;
            this.currentRadius = location.radius;
            Object.assign(this.form, location);
        },
        updateLocation(location) {
            axios.put(`${actions.LOCATION}/${location.id}`, location).then(() => {
                console.log("Location updated", location);
            });
        },
        deleteLocation() {
            if (this.selectedLocation) {
                axios.delete(`${actions.LOCATION}/${this.selectedLocation.id}`).then(() => {
                    this.map.removeLayer(this.selectedLocation.marker);
                    this.map.removeLayer(this.selectedLocation.circle);
                    this.locations = this.locations.filter((l) => l.id !== this.selectedLocation.id);
                    this.selectedLocation = null;
                });
            }
        },
        updateRadius() {
            if (this.selectedLocation && this.selectedLocation.circle) {
                const updatedLocation = {
                    id: this.selectedLocation.id,
                    name: this.selectedLocation.name,
                    code: this.selectedLocation.code,
                    radius: this.currentRadius,
                    latitude: this.selectedLocation.lat,
                    longitude: this.selectedLocation.lng,
                    description: this.selectedLocation.description,
                    time_zone: this.selectedLocation.time_zone,
                };
                this.selectedLocation.circle.setRadius(Number(this.currentRadius));
                this.updateLocation(updatedLocation);
            }
        },
        resetForm() {
            this.form = { name: "", code: "", lat: "", lng: "", description: "", time_zone: "" };
            this.currentRadius = 400;
            this.closeModal();
        },
        onSearch() {
            const query = this.searchQuery.trim().toLowerCase();
            if (query.length >= 3) {
                this.filteredLocations = this.locations.filter(location => {
                    return location.name.toLowerCase().includes(query) || location.code.toLowerCase().includes(query);
                });
            } else {
                this.filteredLocations = [];
            }
        },
        centerMap(location) {
            if (this.map && location.lat && location.lng) {
                this.map.setCenter({ lat: parseFloat(location.lat), lng: parseFloat(location.lng) });
                this.map.setZoom(14);
                this.filteredLocations = [];
            }
        },
        confirmed() {
            this.deleteLocation();
            this.closeModal();
            this.cancelled();
        },
        cancelled() {
            $("#location-delete").modal('hide');
            this.deleteConfirmationModalActive = false;
        },
        getTimeZones() {
            let url = actions.GENERAL_SETTINGS;
            this.axiosGet(url).then(response => {
                this.timeZones = response.data.time_zones;
            }).catch(({response}) => {
            }).finally(()=>{
                this.preloader=false;
            });
        },
        initSearchBar() {
            const input = document.createElement('input');
            input.type = 'text';
            input.placeholder = 'Rechercher un lieu...';
            input.style.cssText = 'position: absolute; top: 10px; left: 50%; transform: translateX(-50%); width: 300px; padding: 10px; z-index: 1000;';
            this.$refs.map.appendChild(input);

            const searchBox = new google.maps.places.SearchBox(input);
            this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(input);

            searchBox.addListener('places_changed', () => {
                const places = searchBox.getPlaces();
                if (places.length === 0) return;

                const bounds = new google.maps.LatLngBounds();
                places.forEach(place => {
                    if (!place.geometry || !place.geometry.location) return;

                    bounds.extend(place.geometry.location);
                    this.map.setCenter(place.geometry.location);
                    this.map.setZoom(14);
                });
            });
        },
    },
};
</script>

<style>
#map {
    height: 95%;
    width: 100%;
    float: left;
    position: relative;
}
.table-container {
    width: 40%;
    float: right;
    padding: 20px;
}
.radius-slider-container {
    background: #2983D2;
    color: white;
    padding: 10px;
    border-radius: 5px;
    z-index: 1000;
}
.delete-button-container {
    position: absolute;
    top: 300px;
    left: 10px;
    background: white;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    z-index: 1000;
}
.custom-tooltip {
    pointer-events: none;
}
.search-bar-container {
        position: relative;
        display: inline-block;
}
.search-bar {
        width: 100%;
        padding: 10px;
        font-size: 16px;
}
.autocomplete-results {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        z-index: 1000;
}
.autocomplete-results ul {
        list-style: none;
        margin: 0;
        padding: 0;
}
.autocomplete-results li {
        padding: 10px;
        cursor: pointer;
}
.autocomplete-results li:hover {
        background: #f0f0f0;
}
</style>
